import script from "./BasicLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicLayout.vue?vue&type=script&setup=true&lang=js"

import "./BasicLayout.vue?vue&type=style&index=0&id=4ed2bd15&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ed2bd15"]])

export default __exports__